// extracted by mini-css-extract-plugin
export default {"main-content":"IndexCollectionManagementTable_main-content__Oipqp","textLink":"IndexCollectionManagementTable_textLink__JyPc3"};